import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';
import {
  DEFAULT_SCHEDULER_TIMEZONE,
  SCHEDULER_TIMEZONE_GROUPS,
  extraTimezoneOptionIfNeeded,
  formatGmtOffset,
  formatTimezoneOptionLabel,
  resolveSchedulerTimezoneSelectValue,
} from './scheduledJobTimezones';

/**
 * Picklist of popular IANA timezones for scheduled jobs.
 */
export default function SchedulerTimezoneSelect({
  value,
  onChange,
  disabled,
  label = 'Timezone',
  required,
  className = 'mb-3',
}) {
  const selectValue = resolveSchedulerTimezoneSelectValue(value);
  const extra = useMemo(() => {
    const row = extraTimezoneOptionIfNeeded(value);
    if (!row) return null;
    return {
      ...row,
      label: `${row.label} (${formatGmtOffset(row.value)})`,
    };
  }, [value]);

  const defaultHint = useMemo(
    () => formatGmtOffset(DEFAULT_SCHEDULER_TIMEZONE),
    []
  );

  return (
    <Form.Group className={className}>
      <Form.Label>
        {label}
        {required ? <span className="text-danger"> *</span> : null}
      </Form.Label>
      <Form.Select
        value={selectValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        required={required}
      >
        {extra ? (
          <option value={extra.value}>{extra.label}</option>
        ) : null}
        {SCHEDULER_TIMEZONE_GROUPS.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {formatTimezoneOptionLabel(opt)}
              </option>
            ))}
          </optgroup>
        ))}
      </Form.Select>
      <Form.Text className="text-muted">
        Offsets shown are current GMT (includes daylight saving). Default: India — Kolkata (
        {defaultHint}).
      </Form.Text>
    </Form.Group>
  );
}
